import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import { orderDetailsSelector } from 'selectors/order/orderDetails/orderDetailsSelector';
import { isAnonymousSelector } from 'selectors/auth/isAnonymousSelector';
import AfterpayActions from 'actions/AfterpayActions';
import UserActions from 'actions/UserActions';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import AfterpayPaymentMethodEN from 'components/Afterpay/AfterpayPaymentMethod/locales/AfterpayPaymentMethod_en_US';
import AfterpayPaymentMethodFR from 'components/Afterpay/AfterpayPaymentMethod/locales/AfterpayPaymentMethod_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { toggleSelectAsDefaultPayment } = UserActions;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const { loadWidget, updateWidget } = AfterpayActions;
const getText = getLocalisedDataFromResource(AfterpayPaymentMethodEN, AfterpayPaymentMethodFR);

const fields = createSelector(
    userSelector,
    orderDetailsSelector,
    isAnonymousSelector,
    createStructuredSelector({
        widgetErrorUS: getTextFromResource(getText, 'widgetError', ['Cash App Afterpay']),
        widgetErrorCA: getTextFromResource(getText, 'widgetError', ['Afterpay']),
        legalNoticeUS: getTextFromResource(getText, 'legalNotice', [
            'Cash App Afterpay',
            'https://www.afterpay.com/en-US/terms-of-service',
            'https://www.afterpay.com/en-US/privacy-policy'
        ]),
        legalNoticeCAFR: getTextFromResource(getText, 'legalNotice', [
            'Afterpay',
            'https://www.afterpay.com/fr-CA/terms-of-service',
            'https://www.afterpay.com/fr-CA/privacy-policy'
        ]),
        legalNoticeCAEN: getTextFromResource(getText, 'legalNotice', [
            'Afterpay',
            'https://www.afterpay.com/en-CA/terms-of-service',
            'https://www.afterpay.com/en-CA/privacy-policy'
        ])
    }),
    (user, orderDetails, isAnonymous, textResources) => {
        const amount = orderDetails?.priceInfo?.creditCardAmount || orderDetails?.priceInfo?.paypalAmount;
        const checked = user.selectedAsDefaultPaymentName === 'afterpay';

        return {
            amount,
            checked,
            isAnonymous,
            ...textResources
        };
    }
);

const functions = {
    loadWidget,
    updateWidget,
    toggleSelectAsDefaultPayment
};

const withAfterpayPaymentMethodProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withAfterpayPaymentMethodProps
};
